export default __webpack_public_path__ + "static/media/trash-bin.fe98da8b.svg";